import { FunctionComponent } from "react";

const Header14: FunctionComponent = () => {
  return (
    <div className="relative bg-background-dark w-full h-[890px] overflow-hidden text-left text-lg text-background-light font-heading-h2-header">
      <div className="absolute h-[67.42%] w-[33.57%] top-[21.01%] right-[15.36%] bottom-[11.57%] left-[51.07%] text-center text-colors-text">
        <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%]">
          <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-[10px] bg-background-light" />
        </div>
        <div className="absolute top-[calc(50%_+_229px)] left-[69.15%] leading-[28px] font-medium text-action-primary text-left">
          Sign In
        </div>
        <div className="absolute top-[calc(50%_+_229px)] left-[21.28%] leading-[28px] font-medium">
          Do you have an Account?
        </div>
        <div className="absolute h-[8.33%] w-[70.21%] top-[74.83%] right-[14.89%] bottom-[16.83%] left-[14.89%] text-background-light">
          <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-81xl bg-socials-twitter" />
          <div className="absolute top-[calc(50%_-_13px)] left-[calc(50%_-_69px)] leading-[26px] font-medium">
            Login via Twitter
          </div>
        </div>
        <div className="absolute h-[8.33%] w-[70.21%] top-[56.33%] right-[14.89%] bottom-[35.33%] left-[14.89%] text-background-light">
          <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-81xl bg-action-secondary" />
          <div className="absolute top-[calc(50%_-_13px)] left-[calc(50%_-_28px)] leading-[26px] font-medium">
            Sign In
          </div>
        </div>
        <div className="absolute h-[4.33%] w-[69.79%] top-[67.73%] right-[15.43%] bottom-[27.93%] left-[14.79%] text-base">
          <img
            className="absolute h-[7.69%] w-[43.77%] top-[42.69%] right-[-0.3%] bottom-[49.62%] left-[56.53%] max-w-full overflow-hidden max-h-full mix-blend-normal"
            alt=""
            src="/divider.svg"
          />
          <div className="absolute top-[calc(50%_-_13px)] left-[calc(50%_-_9.5px)] leading-[26px] opacity-[0.9] mix-blend-normal">
            or
          </div>
          <img
            className="absolute h-[7.69%] w-[43.77%] top-[42.69%] right-[56.53%] bottom-[49.62%] left-[-0.3%] max-w-full overflow-hidden max-h-full mix-blend-normal"
            alt=""
            src="/divider1.svg"
          />
        </div>
        <div className="absolute w-[calc(100%_-_205px)] top-[284px] right-[135px] left-[70px] h-[26.4px] text-left text-base">
          <div className="absolute top-[0.4px] left-[37px] leading-[26px]">
            I agree to the Terms of Service.
          </div>
          <div className="absolute h-[90.91%] w-[9.06%] top-[0%] right-[90.94%] bottom-[9.09%] left-[0%]">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-md bg-action-primary" />
            <img
              className="absolute h-[33.33%] w-[48.33%] top-[35.83%] right-[25.83%] bottom-[30.83%] left-[25.83%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/check-icon.svg"
            />
          </div>
        </div>
        <div className="absolute h-[8.33%] w-[70.21%] top-[34%] right-[14.89%] bottom-[57.67%] left-[14.89%] text-left">
          <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-81xl box-border mix-blend-normal border-[2px] border-solid border-colors-grey" />
          <div className="absolute top-[calc(50%_-_13px)] left-[24px] leading-[26px] font-medium">
            Your password
          </div>
        </div>
        <div className="absolute h-[8.33%] w-[70.21%] top-[22.33%] right-[14.89%] bottom-[69.33%] left-[14.89%] text-left">
          <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-81xl box-border mix-blend-normal border-[2px] border-solid border-colors-grey" />
          <div className="absolute top-[calc(50%_-_13px)] left-[24px] leading-[26px] font-medium">
            Your email
          </div>
        </div>
        <b className="absolute top-[calc(50%_-_252px)] left-[24.26%] text-23xl tracking-[-0.4px] leading-[52px] text-colors-heading">
          Sign Up Now
        </b>
      </div>
      <div className="absolute h-[55.73%] w-[30.5%] top-[24.61%] right-[54.57%] bottom-[19.66%] left-[14.93%] text-3xl">
        <div className="absolute w-[85.01%] top-[48.59%] left-[0.7%] leading-[32px] font-medium inline-block">
          The most important part of the Startup is the samples. The samples
          form a set of 25 usable pages you can use as is or you can add new
          blocks.
        </div>
        <div className="absolute h-[10.08%] w-[36.77%] top-[89.92%] right-[63.23%] bottom-[0%] left-[0%] text-center text-lg">
          <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-81xl bg-action-third" />
          <div className="absolute top-[calc(50%_-_13px)] left-[calc(50%_-_47.5px)] leading-[26px] font-medium">
            Learn More
          </div>
        </div>
        <b className="absolute h-[43.75%] w-[99.3%] top-[0%] left-[0.7%] text-39xl tracking-[-1px] leading-[70px] inline-block">
          Generate Awesome Web Pages
        </b>
      </div>
      <div className="absolute h-[4.49%] w-[69.43%] top-[7.3%] right-[15.36%] bottom-[88.2%] left-[15.21%]">
        <div className="absolute h-full w-[51.75%] top-[0%] right-[0%] bottom-[0%] left-[48.25%]">
          <div className="absolute h-full w-[23.86%] top-[0%] right-[0%] bottom-[0%] left-[76.14%] text-center">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-81xl bg-action-third" />
            <div className="absolute top-[calc(50%_-_13px)] left-[calc(50%_-_39px)] leading-[26px] font-medium">
              Purchase
            </div>
          </div>
          <div className="absolute top-[calc(50%_-_12.6px)] left-[52.68%] leading-[26px] font-medium">
            Feedback
          </div>
          <div className="absolute top-[calc(50%_-_12.6px)] left-[38.97%] leading-[26px] font-medium">
            Blog
          </div>
          <div className="absolute top-[calc(50%_-_12.6px)] left-[22.47%] leading-[26px] font-medium">
            Prices
          </div>
          <div className="absolute top-[calc(50%_-_12.6px)] left-[0%] leading-[26px] font-medium opacity-[0.3]">
            Overview
          </div>
        </div>
        <div className="absolute h-[47.5%] w-[11.42%] top-[22.5%] right-[88.58%] bottom-[30%] left-[0%] text-center text-5xl">
          <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%]">
            <b className="absolute top-[-6px] left-[2px] tracking-[-0.29px]">
              Startup 3
            </b>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header14;
